/**
 * Make Formie's multi-page tabs inert.
 *
 * Formie renders each page tab as an anchor and binds its own click handler
 * (`formTabEventListener`), which calls `setPage()` - letting a visitor jump
 * straight to the payment step without completing the pages before it.
 *
 * `pointer-events: none` in donation-form.css blocks the mouse. Removing the
 * href takes the anchors out of the tab order too, so Enter cannot fire the
 * click that Formie is still listening for.
 */
document.querySelectorAll('.fui-tabs [data-fui-page-tab-anchor]').forEach(($anchor) => {
    $anchor.removeAttribute('href')
    $anchor.setAttribute('aria-disabled', 'true')
})
